import { render, staticRenderFns } from "./ChatPreview.vue?vue&type=template&id=15fdbeec&scoped=true"
import script from "./ChatPreview.vue?vue&type=script&lang=js"
export * from "./ChatPreview.vue?vue&type=script&lang=js"
import style0 from "./ChatPreview.vue?vue&type=style&index=0&id=15fdbeec&prod&lang=scss&scoped=true"
import style1 from "./ChatPreview.vue?vue&type=style&index=1&id=15fdbeec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fdbeec",
  null
  
)

export default component.exports